<script setup lang="ts">
import type UiCarousel from '~ui/components/carousel/Carousel.vue'

import AutoPlayPlugin from 'embla-carousel-autoplay'

const { country } = useAuth()

const { data: storyBlokConfig } = useQueryStoryblok.getAppConfig({
  country,
  params: {
    resolve_relations: ['subscribe_modal_quotes'],
  },
})

const quotes = computed(() => storyBlokConfig.value?.story.content.subscribe_modal_quotes.filter(q => typeof q !== 'string'))

const carousel = ref<InstanceType<typeof UiCarousel>>()
const autoPlayPlugin = AutoPlayPlugin()
</script>

<template>
  <UiCarousel
    ref="carousel"
    :plugins="[autoPlayPlugin]"
  >
    <UiCarouselContent>
      <UiCarouselItem
        v-for="quote in quotes"
        :key="quote.uuid"
      >
        <SubscriptionTestimonialCard
          class="select-none"
          :content="quote.content"
        />
      </UiCarouselItem>
    </UiCarouselContent>
  </UiCarousel>

  <div class="flex items-center justify-center gap-2 p-6">
    <button
      v-for="(_, index) in quotes"
      :key="index"
      :class="{ 'bg-gray-800': carousel?.selectedScrollSnapIndex === index }"
      class="size-1.5 rounded-full bg-gray-300 transition-colors duration-300"
      @click="carousel?.carouselApi?.scrollTo(index)"
    />
  </div>
</template>
